export const CustomerFields = ({ value, onChange, prefix }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <div>
        <label className="label">Full Name *</label>
        <input className="field" required value={value.name} onChange={set("name")} data-testid={`${prefix}-name-input`} />
      </div>
      <div>
        <label className="label">Phone Number *</label>
        <input className="field" required type="tel" value={value.phone} onChange={set("phone")} data-testid={`${prefix}-phone-input`} />
      </div>
      <div>
        <label className="label">Email Address *</label>
        <input className="field" required type="email" value={value.email} onChange={set("email")} data-testid={`${prefix}-email-input`} />
      </div>
      <div>
        <label className="label">Needed By Date</label>
        <input className="field [color-scheme:dark]" type="date" value={value.needed_by} onChange={set("needed_by")} data-testid={`${prefix}-needed-by-input`} />
      </div>
    </div>
  );
};

export const emptyCustomer = { name: "", phone: "", email: "", needed_by: "" };
